import { render, staticRenderFns } from "./CreateNewLead.vue?vue&type=template&id=efb9dd6c&scoped=true"
import script from "./CreateNewLead.vue?vue&type=script&lang=js"
export * from "./CreateNewLead.vue?vue&type=script&lang=js"
import style0 from "./CreateNewLead.vue?vue&type=style&index=0&id=efb9dd6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb9dd6c",
  null
  
)

export default component.exports